/*
 * @Author: czj
 * @Date: 2023-06-12 17:27:22
 * @Description: 
 * @FilePath: \test-demo2\src\utils\request.js
 */
import axios from "axios";
import { useStore } from '@/Store/index';
import { ElMessage } from 'element-plus';

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 0,
})
//请求
service.interceptors.request.use(
  config => {
    const store = useStore(); // 在拦截器内部调用 store
    if (store.ticket) config.headers['ticket'] = store.ticket;
    return config
  },
  error => {
    console.error(error)
    return Promise.reject(error)
  }
)
//响应
service.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.status === 200) {
      return res
    }
    if (res.status !== 200 && res.status !== 10000) {
      if (typeof res.msg === 'string') {
        ElMessage({
          message: res.msg || 'Error',
          type: 'error',
          duration: 5 * 1000
        })
      }
    }
    return res
  },
  error => {
    let tipMsg = '';
    if (error.response) {
      let errRes = error.response;
      if (errRes.status === 500) {
        if (errRes.data && errRes.data.msg) {
          tipMsg = errRes.data.msg
        } else if (errRes.data && errRes.data.message) {
          tipMsg = errRes.data.message
        } else {
          tipMsg = '500,请求失败！'
        }
      } else if (errRes.status === 429) {
        tipMsg = '请勿频繁操作，请在1分钟后尝试操作！'
      } else if (errRes.status === 401) {
        tipMsg = errRes.data && errRes.data.message ? errRes.data.message : '401'
      } else if (errRes.status === 404) {
        tipMsg = '非法请求！！'
      } else if (errRes.status === 422) {
        let errData = error.response.data
        if (Array.isArray(errData.message) && errData.message.length) {
          tipMsg = errData.message.join('；')
        } else {
          tipMsg = errData.message
        }
      } else {
        tipMsg = errRes.status
      }
    } else {
      tipMsg = error.message || '网络错误'
    }
    ElMessage({
      message: tipMsg || '网络错误',
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service